// Mirror of back/helpers/postUnpublishable.js for the UI. Lets the post
// failure/detail modal decide which published platforms can be taken down
// (unpublished) — per platform or all at once — using the same rule the
// server enforces, so the user never sees an action that'd 409.
//
// A post's postingResults.success[] holds one entry per platform it was
// actually published to ({ accountId, provider, postId, url }). "Unpublish"
// deletes those live shares via each platform's delete API.

export function livePlatformsToUnpublish(post, platform = null) {
  const success = Array.isArray(post && post.postingResults && post.postingResults.success)
    ? post.postingResults.success
    : [];
  if (!platform) return success.slice();
  const p = String(platform).toLowerCase();
  return success.filter((e) => String(e && e.provider).toLowerCase() === p);
}

export function canUnpublish(post, platform = null) {
  return livePlatformsToUnpublish(post, platform).length > 0;
}
